(() => {
    const image = qs('.js-engagement-commitment__img');
    const header = qs('.js-header-sticky');
    const breakpoint = window.matchMedia('(min-width: 990px)');

    window.addEventListener('scroll', () => { 
        if (image && breakpoint.matches) {
            image.style.top = `${header.offsetHeight}px`;
        }
    });
})();